import React from 'react';

import Background from '../components/background.js';
import Header from '../components/common/header';
import { Box, Container } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom'; // İçerik değişimini yönetmek için
import Footer from '../components/common/footer';

const Layout = () => {
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {location.pathname === '/' && <Background />}

      <Header />

      <Container
        sx={{
          flexGrow: 1, // Sayfanın geri kalanını kaplasın
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'start',
        }}
      >
        <Outlet />
      </Container>

      {location.pathname === '/' && <Footer />}
    </Box>
  );
};

export default Layout;
